import clsx from 'clsx';
import type * as React from 'react';

import * as api from '@gitbook/api-client';
import { Picker, type PickerItemData } from '@gitbook/react-uikit';
import { FieldGroup, Label } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../types';

/**
 * Settings to configure the style for corners
 */
export function ThemeCornersSettings(props: SitesCustomizationPanelProps): React.ReactElement {
    const { settings, setSettings } = props;

    return (
        <FieldGroup orientation="horizontal">
            <Label>Corner style</Label>
            <Picker
                value={settings.styling.corners}
                items={OPTIONS}
                onValueChange={(value) => {
                    setSettings((prev) => ({
                        ...prev,
                        styling: {
                            ...prev.styling,
                            corners: value,
                        },
                    }));
                }}
            />
        </FieldGroup>
    );
}

const OPTIONS: PickerItemData<api.CustomizationCorners>[] = [
    {
        value: api.CustomizationCorners.Straight,
        label: 'Straight',
        icon: <CornerIcon value={api.CustomizationCorners.Straight} />,
    },
    {
        value: api.CustomizationCorners.Rounded,
        label: 'Rounded',
        icon: <CornerIcon value={api.CustomizationCorners.Rounded} />,
    },
    {
        value: api.CustomizationCorners.Circular,
        label: 'Circular',
        icon: <CornerIcon value={api.CustomizationCorners.Circular} />,
    },
];

/**
 * Small illustration to show the difference between rounded and straight corners.
 */
function CornerIcon(props: {
    value: api.CustomizationCorners;
    size?: number;
    className?: string;
}): React.ReactElement {
    const { value, className, size } = props;

    return (
        <div
            className={clsx('relative flex rounded-sm border bg-base', className)}
            style={{
                width: size,
                height: size,
            }}
        >
            <div
                className={clsx(
                    'absolute right-0 bottom-0 size-3/4 border-control border-t border-l bg-muted',
                    value === api.CustomizationCorners.Rounded && 'rounded-tl-md',
                    value === api.CustomizationCorners.Circular && 'rounded-tl-full'
                )}
            />
        </div>
    );
}
